// extracted by mini-css-extract-plugin
export default {"header":"KZqY78HuG5rGX87KOhfA","headline":"y3LPxCUzSRYgLJ9INO0l","list":"Z128yy7D5fhSJnyzmBiz","pagination":"pMxv4fXe6oYRIyeBvH9F"};